import { ITranslations } from 'types/common';
import { PointLogsTableTransFields } from './types';
import en from 'translations/en/pointsLogsTable.json';
import pl from 'translations/pl/pointsLogsTable.json';
import sl from 'translations/sl/pointsLogsTable.json';

export const pointLogsTableTranslations: ITranslations<PointLogsTableTransFields> = {
  name: 'pointLogsTable',
  en,
  pl,
  sl,
};
